module.exports = __webpack_public_path__ + "img/etsy.b0b31569.png";